import React from 'react';
import styled from 'styled-components';
import { string, func, object } from 'prop-types';
import { replace } from 'lodash';
import { FormDatePicker, FlexContainer, Row, Button, SalesChannelByCompanySelect } from '../../common';

const SpaceBetween = styled.div`
    width: ${({ width }) => width};
`;

const Filters = ({ currentValue, onChangeSalesChannels, onChangeFilters, initialSaleChannelSelected, onChangeDateRange }) => {
    const fullWidth = currentValue === '100%';
    const spaceBetweenWidth = fullWidth ? '0px' : '13px';

    return (
        <FlexContainer style={{ padding: 23 }}>
            <Row
                border='1px solid #eaeaea'
                borderRadius={3}
                padding='3px 13px'
                backgroundColor='white'
            >
                <FormDatePicker
                    range
                    label='Rango de entrega'
                    width={currentValue}
                    onChange={(values) => onChangeDateRange(values)}
                    mobile={fullWidth}
                />
                <SpaceBetween width={spaceBetweenWidth} />
                <SalesChannelByCompanySelect width={currentValue} onChangeSalesChannels={onChangeSalesChannels} />
                <SpaceBetween width={spaceBetweenWidth} />
                <FlexContainer
                    width={fullWidth ? '100%' : undefined}
                    align='flex-end'
                    mB={10}
                >
                    <Button
                        text='Buscar'
                        onClick={onChangeFilters}
                    />
                </FlexContainer>
            </Row>
        </FlexContainer>
    );
};

Filters.propTypes = {
    currentValue: string,
    initialSaleChannelSelected: object,
    onChangeSalesChannels: func,
    onChangeDateRange: func,
    onChangeFilters: func
};

export default Filters;
